import { z } from 'zod';
import type { MapReadAddress } from '@/types/mapReadAddress';
import { toTitleCase } from '@/utils/format';

export interface DriverAddressApi extends MapReadAddress {
  neighborhood?: {
    id: string;
    name: string;
    city?: { name?: string } | null;
  } | null;
}

export interface DriverApi {
  id: string;
  securityId: string;
  firstName: string;
  lastName: string;
  documentTypeId?: string;
  documentNumber?: string;
  email: string;
  personalPhoneNumber?: string | null;
  workPhoneNumber?: string | null;
  workStatusId?: string;
  status: string;
  currentOperatorId?: string | null;
  addressId?: string;
  externalId?: string | null;
  legacyNumber?: string | null;
  birthDate?: string;
  createdAt?: string;
  updatedAt?: string;
  currentOperator?: {
    id: string;
    name: string;
  } | null;
  logisticOperators?: Array<{
    id: string;
    logisticOperatorId: string;
    status: string;
    logisticOperator: {
      id: string;
      name: string;
    };
  }>;
  address?: DriverAddressApi | null;
}

export interface DriversFilter {
  search?: string;
  email?: string;
  phone?: string;
  status?: string;
  currentOperatorId?: string;
  assignableToOperatorId?: string;
  assignableToRouteOperatorId?: string;
}

export const editDriverSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(1, 'El nombre es obligatorio')
    .max(50, 'El nombre no puede exceder 50 caracteres')
    .transform(toTitleCase),
  lastName: z
    .string()
    .trim()
    .min(1, 'El apellido es obligatorio')
    .max(50, 'El apellido no puede exceder 50 caracteres')
    .transform(toTitleCase),
  email: z
    .string()
    .trim()
    .min(1, 'El correo es obligatorio')
    .email('Correo electrónico inválido'),
  documentNumber: z
    .string()
    .trim()
    .min(1, 'El número de documento es obligatorio')
    .regex(/^\d+$/, 'El número de documento solo puede contener dígitos'),
  legacyNumber: z.string().trim().optional(),
  birthDate: z.date().nullable().optional(),
  workPhoneNumber: z
    .string()
    .trim()
    .transform((value) => value.replace(/\D/g, ''))
    .optional(),
  personalPhoneNumber: z
    .string()
    .trim()
    .transform((value) => value.replace(/\D/g, ''))
    .optional(),
});

export type EditDriverSchema = z.infer<typeof editDriverSchema>;

export const defaultEditDriverValues: EditDriverSchema = {
  firstName: '',
  lastName: '',
  email: '',
  documentNumber: '',
  legacyNumber: '',
  birthDate: null,
  workPhoneNumber: '',
  personalPhoneNumber: '',
};
